import AvatarProfileIcon from './component'

export default AvatarProfileIcon
